export default __webpack_public_path__ + "static/media/fuel-level-point.866106a4.svg";